import { AutoMap } from "@automapper/classes";
import { AppareilDTO } from "./appareil.dto";
import { PrelevementDTO } from "./prelevement.dto";
import { ZoneCompareDTO } from "./zone-compare.dto";
import { SoufflageDTO } from "./soufflage.dto";
import { RepriseDTO } from "./reprise.dto";

export class PrelevementQualifSalleDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    observations: string = ''
    @AutoMap()
    personnesPresentes?: number;
    @AutoMap()
    systemeTraitementAir?: number;

    @AutoMap()
    localisationDeSalle?: number
    @AutoMap()
    autreLocalisationDeSalle: string = ''
    @AutoMap()
    classe?: number
    // @AutoMap()
    // heureDebut?: string
    @AutoMap()
    surfaceZAC?: number
    @AutoMap()
    volume?: number
    /** BASE 64 IMAGE */
    @AutoMap()
    plan: string = ''
    @AutoMap()
    temperature?: number
    @AutoMap()
    humidite?: number
    @AutoMap()
    luminosite?: number
    @AutoMap()
    pressionAcoustique?: number
    @AutoMap()
    testFumee?: number

    @AutoMap()
    pourcentageAirNeuf?: number
    @AutoMap()
    type?: number
    @AutoMap()
    produitDangereux: boolean = false

    @AutoMap(() => [ZoneCompareDTO])
    zoneAComparerList: ZoneCompareDTO[] = [];

    @AutoMap(() => [ZoneCompareDTO])
    zoneAComparerSasList: ZoneCompareDTO[] = []

    @AutoMap(() => [SoufflageDTO])
    soufflageList: SoufflageDTO[] = [];
    @AutoMap(() => [RepriseDTO])
    repriseList: RepriseDTO[] = [];

    @AutoMap()
    prelevement: PrelevementDTO = new PrelevementDTO()
    // @AutoMap(() => [AppareilDTO])
    // appareilQualifList: AppareilDTO[] = []  
}